import ParticipantMessagingSelect, {
  SetParticipantMessagingMutationFn,
} from './ParticipantMessagingSelect';
import React from 'react';
import { isNil } from 'lodash';
import { ParticipantMessagingState } from 'globalTypes';

const ParticipantMessagingSelectContainer = ({
  participantMessagingFromBackend,
  participantMessagingSchoolDefault,
  groupUuid,
  participantMessagingFromFrontend,
  setParticipantMessagingValue,
  disabled,
}: {
  participantMessagingFromBackend: string;
  participantMessagingSchoolDefault: string;
  groupUuid: string | null | undefined;
  participantMessagingFromFrontend: string | undefined | null;
  setParticipantMessagingValue: (participantMessagingValue: string) => void;
  disabled: boolean;
}) => {
  const participantMessaging = isNil(participantMessagingFromFrontend)
    ? participantMessagingFromBackend
    : participantMessagingFromFrontend;

  const participantMessagingSelect = (
    setParticipantMessaging: SetParticipantMessagingMutationFn,
    participantMessagingValue: string
  ) => {
    if (groupUuid) {
      setParticipantMessaging({
        variables: {
          uuid: groupUuid,
          input: {
            participantMessagingState: participantMessagingValue as ParticipantMessagingState,
          },
        },
      });
    }
    setParticipantMessagingValue(participantMessagingValue);
  };

  return (
    <ParticipantMessagingSelect
      participantMessagingSchoolDefault={participantMessagingSchoolDefault}
      participantMessaging={participantMessaging}
      participantMessagingSelect={participantMessagingSelect}
      disabled={disabled}
    />
  );
};

export default ParticipantMessagingSelectContainer;
